export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function timeAgo(dateStr) {
  const now = new Date();
  const date = new Date(dateStr);
  const diff = Math.floor((now - date) / 1000);
  if (diff < 60) return "just now";
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  if (diff < 604800) return `${Math.floor(diff / 86400)}d ago`;
  return date.toLocaleDateString();
}

export const INTENT_COLORS = {
  confident: { bg: "#006039", border: "#006039", text: "#006039" },
  polite: { bg: "#0F6E56", border: "#0F6E56", text: "#0F6E56" },
  genz: { bg: "#1A3A5C", border: "#1A3A5C", text: "#1A3A5C" },
  apologize: { bg: "#A67C52", border: "#A67C52", text: "#A67C52" },
  flirty: { bg: "#8B3A4A", border: "#8B3A4A", text: "#8B3A4A" },
  professional: { bg: "#3A3A38", border: "#3A3A38", text: "#3A3A38" },
  short: { bg: "#4A5568", border: "#4A5568", text: "#4A5568" },
  humanize: { bg: "#8B4513", border: "#8B4513", text: "#8B4513" },
  casual: { bg: "#5B8A72", border: "#5B8A72", text: "#5B8A72" },
  funny: { bg: "#D4842C", border: "#D4842C", text: "#D4842C" },
  caring: { bg: "#7B5EA7", border: "#7B5EA7", text: "#7B5EA7" },
};

export const INTENT_LABELS = {
  confident: "Confident",
  polite: "Polite",
  genz: "Gen-Z",
  apologize: "Apologize",
  flirty: "Flirty",
  professional: "Professional",
  short: "Short",
  humanize: "Humanize",
  casual: "Casual",
  funny: "Funny",
  caring: "Caring",
};

export const PLATFORM_LABELS = {
  whatsapp: "WhatsApp",
  email: "Email",
  linkedin: "LinkedIn",
  instagram: "Instagram",
  dating: "Dating",
};

export const MODE_LABELS = {
  rewrite: "Rewrite",
  reply: "Reply",
  fix_grammar: "Fix Grammar",
  expand: "Expand",
  explain: "Explain Simply",
};
